import styled from 'styled-components'
import Box from '@material-ui/core/Box'

export const WhitePage = styled(Box)`
  background: ${props => props.theme.palette.common.white};
  height: 100%;
`
